import { referentialApi } from './referential';
import { subscriptionApi } from './subscription';

export function apiClient() {
  return Object.freeze({
    referential: referentialApi(),
    subscription: subscriptionApi(),
  });
}
